import React from "react";

import styled from "styled-components/macro";

import FnrButton3 from "UI/FnrButton3";

export default function SetupWelcomeMessage({ groupName, disabled }) {
  const goToWelcomeMessageSettingPanel = () => {
    let everyoneSettingUrl = `signups/family-registration/${groupName}/settings/network-welcome`;
    let groupSettingUrl = `signups/family-registration/${groupName}/settings/group-welcome`;
    let url =
      groupName.toLowerCase() === "everyone"
        ? everyoneSettingUrl
        : groupSettingUrl;
    window.fnReactBus.goToUrl(url);
  };

  return (
    <Wrapper disabled={disabled}>
      <FnrButton3
        color="blue"
        size="small"
        onClick={goToWelcomeMessageSettingPanel}
        disabled={disabled}
      >
        <i
          className="far fa-envelope-open-text"
          style={{ marginRight: "8px" }}
        />
        <span>Set up Welcome Message</span>
      </FnrButton3>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-top: 20px;
  width: max-content;
  margin-left: 36px;
  opacity: ${(props) => (props.disabled ? 0.65 : 1)};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
`;
